import { action } from "typesafe-actions";
import { RegisterActionTypes } from "./business_user_details.model";

export const registerBusinessRequest = (req) =>
  action(RegisterActionTypes.REGISTER_BUSINESS_REQUEST, req);
export const registerBusinessSuccess = (res) =>
  action(RegisterActionTypes.REGISTER_BUSINESS_SUCCESS, res);
export const registerBusinessFailure = (err) =>
  action(RegisterActionTypes.REGISTER_BUSINESS_FAILURE, err);
